﻿import * as QuoteResultModel from './quoteresult.model';

export interface IQuoteResultSet {
    workersCompQuote: QuoteResultModel.IQuoteResult;
    packageQuote: QuoteResultModel.IQuoteResult;
    deliveryAutoQuote: QuoteResultModel.IQuoteResult;
    aggregateWrittenAmount: number;
}

export class QuoteResultSet implements IQuoteResultSet {
    workersCompQuote: QuoteResultModel.IQuoteResult;
    packageQuote: QuoteResultModel.IQuoteResult;
    deliveryAutoQuote: QuoteResultModel.IQuoteResult;
    aggregateWrittenAmount: number;
}
